import { send } from 'server';
import { complement, isNil } from 'ramda';

export const createPlayerInfo = ({
    casinoName,
    addressDetails,
    contactAddress,
    dataMap,
    token = null,
    blackbox = null
}) => send({
    ID: 31007,
    responses: [31008, 33006],
    description: 'Create Player Info (Register)',
    ...casinoName && { casinoName },
    addressDetails,
    contactAddress,
    dataMap,
    ...token && { token },
    ...blackbox && {
        customData: [
            {
                key: 'iovationBlackbox',
                value: blackbox
            }
        ]
    }
});

export const sendBatchRequest = ({
    authParameters,
    depositLimits,
    betLimits,
    betLimitsAction,
    lossLimits,
    lossLimitsAction,
    contactPreferences,
    tags
}) => send({
    ID: 35508,
    responses: [35516, 35517],
    description: 'Create Player Info (Batch Request)',
    authParameters,
    errorLevel: 1,
    requests: [
        depositLimits && {
            ID: 89904,
            description: 'Set Initial Deposit Limits',
            responses: [89908, 89900],
            limits: depositLimits,
            errorLevel: 1
        },
        betLimits && {
            ID: 35649,
            description: 'Set Initial Bet Limits',
            responses: [35650, 35651],
            action: betLimitsAction || 'message',
            limits: betLimits,
            errorLevel: 1
        },
        lossLimits && {
            ID: 35646,
            description: 'Set Initial Loss Limits',
            responses: [35647, 35648],
            action: lossLimitsAction || 'message',
            limits: lossLimits,
            errorLevel: 1
        },
        contactPreferences && {
            ID: 35513,
            description: 'Set user contact preferences',
            responses: [35514, 35515],
            contactPreferences,
            errorLevel: 1
        },
        tags && {
            ID: 35544,
            responses: [35545, 35546],
            description: 'Set player tags',
            tags,
            errorLevel: 1
        }
    ].filter(complement(isNil))
});

